export default "__VITE_ASSET__CnmQ4uxt__"